import { render, staticRenderFns } from "./Music.vue?vue&type=template&id=21ef0f54&"
import script from "./Music.vue?vue&type=script&lang=js&"
export * from "./Music.vue?vue&type=script&lang=js&"
import style0 from "./Music.vue?vue&type=style&index=0&id=21ef0f54&prod&lang=scss&"
import style1 from "./Music.vue?vue&type=style&index=1&id=21ef0f54&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports